import React, { useEffect, useState } from "react";
import { useMoralis } from "react-moralis";
import { Col, Row } from "antd";
import ReactJson from "react-json-view";


function Debugger() {
  const {  chainId, isAuthenticated, user, account, isWeb3Enabled } = useMoralis();
  const [accountAddress, setAccountAddress] = useState('');
  const [debuggerObject, setDebuggerObject] = useState('');
  const [applicationMode, setApplicationMode] = useState('DEV');
  const [connector, setConnector] = useState('');
 
  
  useEffect(() => {
    setAccountAddress(user?.attributes.ethAddress);
    const connectorId = window.localStorage.getItem("connectorId");
    setConnector(connectorId);
    if(connectorId === "injected"){
      if(accountAddress?.toLowerCase() !== account?.toLowerCase()){
        setAccountAddress(account);
        return;
      }
    }

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, account]);

  useEffect(() => {
    const applicationMode = process.env.REACT_APP_ENV;
    setApplicationMode(applicationMode);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const _debugger = {
      user,
      account,
      accountAddress,
      isAuthenticated,
      chainId,
      isWeb3Enabled,
      applicationMode,
      connector
    }

    setDebuggerObject(_debugger);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, account, accountAddress,isAuthenticated, chainId, isWeb3Enabled ]);

  return (
    <Row gutter={20}>
      <Col xs={24} sm={24} md={24} lg={24} xl={24}>
         <div className="debugger-object">
         <ReactJson
              name={false}
              displayObjectSize={false}
              displayDataTypes={false}
              enableClipboard={false}
              src={debuggerObject}
              theme="monokai"
            />
         </div>
      </Col>
    </Row>
  );
}

export default Debugger;
